import React from 'react'
import {Button} from "@blueprintjs/core"
import {getScheduledDeliveryTS, getTravelTime, REMINDER_OPTION_BEFORE_DUE_MS} from '../scheduledDelivery'
import {
  MINUTE, displayMilli, displayChoiceTime, floorToFiveMinutes,
  saveUpdates, SaveStatusNotice, TimeChoiceCards
} from './pickupTimeChoices'

import './PickupTimeEstimate.scss'

const PLACE_REQUEST_BEFORE_READY_MS = 15 * MINUTE

export default function PickupTimeEstimate ({snapshot, settings={}}) {
  const id = snapshot.key
  const order = snapshot.val()
  const {r_id} = order
  const notify_id = `${id}${r_id}`
  const orderPath = `orders/${snapshot.ref.parent.key}/${id}`
  const placeRequestPath = `notify/${notify_id}/placeRequestTS`

  const worstCaseTS = snapshot.child('pickupReadyTS/worstCaseTS').val()
  const doNotDispatch = !!order.doNotDispatch
  const pickupReminderTS = Number(order.pickupReminderTS) || null
  const scheduledTS = getScheduledDeliveryTS(order)
  const {delivery={}} = settings
  const isThirdPartyDriverShop = !!delivery.deliverWithPostmates

  const estimateOptions = [
    { label: "now",   minutesDelay: [0,  0] },
    { label: "10min",   minutesDelay: [5,  10] },
    { label: "15min",   minutesDelay: [5,  15] },
    { label: "20min",  minutesDelay: [15, 20] },
    { label: "25min",  minutesDelay: [15, 25] },
    { label: "30min",  minutesDelay: [30, 30] },
    { label: "40min",  minutesDelay: [30, 40] },
    { label: "50min",  minutesDelay: [30, 50] },
    // { label: "60min",  minutesDelay: [30, 60] },
  ]

  function commitTS ({bestCaseTS, worstCaseTS}) {
    const updates = {
      [`${orderPath}/pickupReadyTS`]: {bestCaseTS, worstCaseTS},
      [placeRequestPath]: Number(worstCaseTS) - PLACE_REQUEST_BEFORE_READY_MS,
    }
    // only touch doNotDispatch when set: a denied path rejects the whole multi-path update
    if (doNotDispatch) { updates[`${orderPath}/doNotDispatch`] = null }
    saveUpdates(id, updates, function textCustomer () {
      fetch(`https://sendcustomertext-ola2biwnka-uc.a.run.app/msg`, {
        method: 'post', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: id, shopId: r_id, worstCaseTS, cartType: 'DELIVERY' })
      }).then(() => {}).catch((e) => {console.log(e)})
    })
  }

  function commitDoNotDispatch () {
    saveUpdates(id, {
      [`${orderPath}/pickupReadyTS`]: null,
      [`${orderPath}/doNotDispatch`]: true,
      // marks the order handled for overdue checks in afaNotificationsCron
      [`${orderPath}/orderAcceptedByShop`]: true,
      [placeRequestPath]: null,
    })
  }

  function commitReminder () {
    saveUpdates(id, {
      [`${orderPath}/pickupReminderTS`]: scheduledTS - REMINDER_OPTION_BEFORE_DUE_MS,
    })
  }

  function resetPickupTS () {
    const updates = {
      [`${orderPath}/pickupReadyTS`]: null,
      [placeRequestPath]: null,
    }
    if (doNotDispatch) {
      updates[`${orderPath}/doNotDispatch`] = null
      updates[`${orderPath}/orderAcceptedByShop`] = null
    }
    saveUpdates(id, updates)
  }

  function setMinutesDelay ([bestCaseMinutesDelay, worstCaseMinutesDelay]) {
    const nowTS = Date.now()
    commitTS({
      worstCaseTS: nowTS + worstCaseMinutesDelay * MINUTE,
      bestCaseTS: nowTS + bestCaseMinutesDelay * MINUTE,
    })
  }

  const now = Date.now()
  const travelTime = getTravelTime(order)
  const recommendedTS = scheduledTS ? floorToFiveMinutes(scheduledTS - travelTime.minutes * MINUTE) : null
  const earlierTS = recommendedTS ? recommendedTS - 15 * MINUTE : null
  const reminderTS = scheduledTS ? scheduledTS - REMINDER_OPTION_BEFORE_DUE_MS : null

  return(
    <section className="todo-item">
      <header
        style={{
          fontWeight: 600,
        }}
        >{isThirdPartyDriverShop ? 'Provide PickUp time for 3rd Party Driver:' : 'When is food ready for driver?'}</header>
      <p style={{
        marginLeft: "0.3em",
        padding: "0.1em 0.2em",
        borderRadius: "0.2em",
        backgroundColor: "#f6d009",
        display: "inline-block"
      }} className="notice">
        driver needs pickup time
      </p>

      <SaveStatusNotice orderId={id} />

      {(worstCaseTS || doNotDispatch) ?
        <div>
          <div>{doNotDispatch ? 'No driver will be dispatched for this order' : displayMilli(worstCaseTS)}</div>
          <Button large onClick={resetPickupTS}>Pick Different Ready Time</Button>
        </div>
        :
        <div>
          <TimeChoiceCards
            earlierTS={earlierTS}
            recommendedTS={recommendedTS}
            showNow={!!scheduledTS}
            onPick={(ts) => commitTS({worstCaseTS: ts, bestCaseTS: ts})} />

          {/* scheduled orders get the NOW card instead of the "from now" row */}
          {!scheduledTS && estimateOptions.map(({label, minutesDelay}) => {
            return(
              <Button
                large
                key={label}
                className="minutes-delay-button"
                onClick={setMinutesDelay.bind(this, minutesDelay)}
                >{label}</Button>
            )
          })}

          <div className="pickup-secondary-actions">
            {scheduledTS && (
              pickupReminderTS ?
                <p className="reminder-set">Reminder set for {displayChoiceTime(pickupReminderTS)}</p>
              : (reminderTS > now) &&
                <Button icon="notifications" onClick={commitReminder}
                  >remind me 1hr before due time</Button>
            )}
            <Button intent="warning" icon="disable" onClick={commitDoNotDispatch}
              >do not dispatch driver for this order</Button>
          </div>
        </div>
      }
    </section>
  )
}
